// api定义
const api = {
	listServiceModulePrivileges: '/module/listServiceModulePrivileges', // 获取所有权限名称
	listAuthorizationRelations: '/acl/listAuthorizationRelations',
	deleteAuthorizationRelation: '/acl/deleteAuthorizationRelation',
	addRule: '/acl/createAuthorizationRelation', // 创建规则
	updateRule: '/acl/updateAuthorizationRelation', // 更新规则
	listServiceModulePrivilegeCustomizeData: '/module/listServiceModulePrivilegeCustomizeData', // 权限细化获取业务自定义数据范围
	getOperations: '/OAAuthorization/getOperations', // 获取操作列表
	getOperationAuthorizations: '/OAAuthorization/getOperationAuthorizations', // 获取操作授权记录
	resetOperationAuthorizations: '/OAAuthorization/resetOperationAuthorizations', // 重置操作授权
	deleteOperationAuthorizations: '/OAAuthorization/deleteOperationAuthorizations', // 删除操作授权
	listCommunities: '/community/listCommunities', // 获取当前域空间所有空间项目
	getDepartments: '/org/getDepartments', // 获取当前公司所有部门
	// 获取用户被授权的空间项目
	getAuthorizedCommunities: '/OAAuthorization/getAuthorizedCommunities',
	// 获取用户被授权的企业范围
	getAuthorizedDepartments: '/OAAuthorization/getAuthorizedDepartments',
	// 获取组织结构
	listAllChildrenOrganizations: '/admin/org/listAllChildrenOrganizations',
	// 获取系管
	getSysAdmins: '/OAAuthorization/getSysAdmins',
	// 获取超管
	getSupAdminInfo: '/OAAuthorization/getSupAdminInfo',
	// 获取有应用管理权限的用户
	getHasAppManagePrivilegesUsers: '/OAAuthorization/getHasAppManagePrivilegesUsers',
	// 导出
	exportOperationAuthorizations: '/OAAuthorization/exportOperationAuthorizations',
	// 空间项目
	getSpacePros: '/OAAuthorization/getAuthorizedCommunitiesWithSpaceGroup',
	//空间项目map
	getSpaceMap: '/spaceGroup/listSpaceGroupWithoutTree',
	getCouponCenterConfig: '/couponCollection/getCouponCenterConfig',
	/**
	 * 权限角色相关api
	 */
	 createPrivilegeRole: '/OAAuthorization/createPrivilegeRole', //创建权限角色
	 updatePrivilegeRole: '/OAAuthorization/updatePrivilegeRole', //更新权限角色
	 deletePrivilegeRole: '/OAAuthorization/deletePrivilegeRole', //查询权限角色
	 listPrivilegeRole: '/OAAuthorization/listPrivilegeRole', //查询权限角色列表
	 /**/

	 /**
		* 权限组相关api
	  */
	checkDataGroupName: '/OAAuthorization/checkDataGroupName', //校验权限组名称是否可用
	createRoleAuthRule: '/OAAuthorization/createRoleAuthRule', //创建角色授权规则
	updateRoleAuthRule: '/OAAuthorization/updateRoleAuthRule', //更新角色授权规则
	deleteRoleAuthRule: '/OAAuthorization/deleteRoleAuthRule', //删除角色授权规则
	getRoleAuthRuleDetail: '/OAAuthorization/getRoleAuthRuleDetail', //查询角色授权规则详情
	listRoleAuthRule: '/OAAuthorization/listRoleAuthRule', //查询角色授权规则列表
};

const rightGroupModalType = {
	EDIT: 'EDIT',
	CREAT: 'CREAT',
	DETAIL: 'DETAIL',
};
// 面包屑配置
const routes = {};
export {
	api, routes, rightGroupModalType
};
